/**
 * Altura das ações no rodapé dos modais do módulo.
 *
 * Sem `height` declarado a altura sai de `padding + conteúdo + borda`, e o
 * `OutlinedButton` (borda de 2px) ficava ~4px mais alto que o `FilledButton` ao
 * lado — "Cancelar"/"Sair" desalinhados do botão de confirmação em todos os
 * modais. Declarar a mesma altura nos dois resolve; as larguras seguem
 * diferentes de propósito, marcando a hierarquia entre as ações.
 */
export const MODAL_ACTION_HEIGHT = '48px'
